import { ReactElement, useEffect } from "react";
import { styled } from "@mui/material";
import { useSelector } from "react-redux";
import { updateBasketCount } from "actions/cartAction";
import { set_basket_count } from "store/reducers/basketSlice";
import { useAppDispatch } from "store/store";

const StyledSpan = styled("span")({
  position: "absolute",
  top: 0,
  left: 0,
  backgroundColor: "#3BD6FF",
  color: "#001838",
  fontSize: "12px",
  padding: "3px 7px",
  borderRadius: "10px",
  lineHeight: 1,
  fontWeight: "bold",
});

const BasketCount: React.FC = (): ReactElement => {
  const count = useSelector((state: any) => state.basket.basket_count);
  const dispatch = useAppDispatch();

  useEffect(() => {
    updateBasketCount()
      .then((res) => {
        if (res.status === 200) {
          dispatch(set_basket_count(res.data));
        }
      })
      .catch((err) => {
        console.log("[ERROR]: ", err);
      });
  }, [dispatch]);

  return ((count > 0) ? <StyledSpan data-testid="basket-count">{count}</StyledSpan> : <></>);
};

export default BasketCount;
